import { render, staticRenderFns } from "./MemberVerifyPage.vue?vue&type=template&id=06499327"
import script from "./MemberVerifyPage.vue?vue&type=script&lang=js"
export * from "./MemberVerifyPage.vue?vue&type=script&lang=js"
import style0 from "./MemberVerifyPage.vue?vue&type=style&index=0&id=06499327&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports